export default "__VITE_ASSET__Z2z3m$fr__"